import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { FirebaseApp } from 'angularfire2';
import 'firebase/storage';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class PagosService {
    firebaseStorage: any;

    constructor(
        private http: HttpClient,
        private afDB: AngularFireDatabase,
        private fbstore: AngularFirestore,
        private firebaseApp: FirebaseApp,
    ) {
        this.firebaseStorage = firebaseApp.storage().ref()
    }

    public obtenerPagosEntreFechas(fechaInicial, fechaFinal, pagados?: boolean) {
        fechaInicial = fechaInicial - 18000000;
        console.log("fechaInicial", fechaInicial)
        fechaFinal = fechaFinal - 18000000;
        console.log("fechaFinal", fechaFinal)
        if (!pagados) {
            console.log("Sin pagar");
            return this.fbstore.collection('pagos', ref => ref.where('estatus', '==', 'Programado').where('fechaSubidaComprobante', '>=', fechaInicial).where('fechaSubidaComprobante', '<=', fechaFinal))
        } else {
            console.log("Pagados");
            return this.fbstore.collection('pagos', ref => ref.where('estatus', '==', 'Pagado').where('fechaSubidaComprobante', '>=', fechaInicial).where('fechaSubidaComprobante', '<=', fechaFinal))
        }
    }

    public obtenerPagosRechazadosEntreFechas(fechaInicial, fechaFinal) {
        fechaInicial = fechaInicial - 18000000;
        fechaFinal = fechaFinal - 18000000;
        return this.fbstore.collection('pagos', ref => ref.where('estatus', '==', 'Rechazado').where('fechaSubidaComprobante', '>=', fechaInicial).where('fechaSubidaComprobante', '<=', fechaFinal))
    }

    public guardarFolioFactura(keyPago, folioFactura) {
        return this.fbstore.collection('pagos').doc(keyPago).update({'folioFactura': folioFactura});
    }

    public actualizarPago(keyPago, campo, valor) {
        let objetoActualizacion = {};
        objetoActualizacion[campo] = valor;
        return this.fbstore.collection('pagos').doc(keyPago).update(objetoActualizacion);
    }

    public obtenerPagosPorUsuarioCreadorPendienteValidar(idUsuario) {
        return this.fbstore.collection('pagos', ref => ref.where('usuarioCreador', '==', idUsuario).where('estatus', '==', 'Pagado').where('aprobacionFinanzas', '==', false))
    }

    public obtenerPagosPagadosDeConfirmacion(id) {
        return this.fbstore.collection('pagos', ref => ref.where('estatus', '==', 'Pagado').where('confirmacion', '==', id))
    }

    public insertarPagoProgramadoEfectivoOperador(pago) {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'id_confirmacion=' + pago.confirmacionId +
            '&monto=' + pago.cantidadOperador;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/editarRutaPagoEfectivo.php', body, {headers});
    }

    /**
     * Genera un nuevo pago en la lista
     * @param pagoDetalle Objeto de pago
     */
    public insertarPagoProgramado(pagoDetalle) {
        //Se arma el objeto de pago para poder ser programado
        let fechaArreglo = pagoDetalle.fechaProgramada.split('-');
        let objetoPagoProgramado = {
            confirmacion: pagoDetalle.confirmacionId,
            confirmacionIdTrosten: pagoDetalle.idTrosten,
            estatus: 'Programado',
            formaDePago: pagoDetalle.formaDePago,
            fechaProgramada: new Date(Number(fechaArreglo[0]), Number(fechaArreglo[1] - 1), Number(fechaArreglo[2])).getTime(),
            procesoDePago: pagoDetalle.procesoDePago,
            total: pagoDetalle.monto
        };
        if (pagoDetalle.ordenCompra)
            objetoPagoProgramado['ordenCompra'] = pagoDetalle.ordenCompra;
        //Una vez  construido el objeto se agrega a la lista de pagos
        return this.fbstore.collection('pagos').add(objetoPagoProgramado)
    }

    public insertarPagoRegistrado(pagoDetalle, keyPago, cliente, nuevoSaldo, idUsuarioCreador) {
        let fechaArreglo = pagoDetalle.fechaDePago.split('-');
        let objetoPagoRegistro = {};

        objetoPagoRegistro = {
            aprobacionFinanzas: false,
            confirmacion: pagoDetalle.confirmacionId,
            confirmacionIdTrosten: pagoDetalle.idTrosten,
            estatus: 'Pagado',
            formaDePago: pagoDetalle.formaDePago,
            fechaDePago: new Date(Number(fechaArreglo[0]), Number(fechaArreglo[1] - 1), Number(fechaArreglo[2])).getTime(),
            fechaProgramada: new Date(Number(fechaArreglo[0]), Number(fechaArreglo[1] - 1), Number(fechaArreglo[2])).getTime(),
            referencia: pagoDetalle.referencia,
            procesoDePago: pagoDetalle.procesoDePago,
            total: pagoDetalle.total,
            subtotal: pagoDetalle.subtotal || 0,
            iva: pagoDetalle.iva || 0,
            usuarioCreador: idUsuarioCreador
        };
        if (pagoDetalle.ordenCompra)
            objetoPagoRegistro['ordenCompra'] = pagoDetalle.ordenCompra;
        if (pagoDetalle.imagenComprobante)
        {
            objetoPagoRegistro['comprobante'] = pagoDetalle.imagenComprobante;
            objetoPagoRegistro['fechaSubidaComprobante'] = Date.now();
        }
        let batch = this.fbstore.firestore.batch();
        let multipathUpdateCotizacionPosible = {};
        let nuevoSaldoAFavor;
        batch.set(this.fbstore.firestore.collection('pagos').doc(keyPago), objetoPagoRegistro, {merge: true});
        if (objetoPagoRegistro['formaDePago'] == 'Saldo a Favor') {
            nuevoSaldoAFavor = nuevoSaldo - pagoDetalle['total']
            multipathUpdateCotizacionPosible['clientes/' + cliente + '/saldoAFavor/'] = nuevoSaldoAFavor;
        }
        let promiseRealtimeDB = this.afDB.object('/').update(multipathUpdateCotizacionPosible);
        let promiseFirestore = batch.commit();
        return Promise.all([promiseRealtimeDB, promiseFirestore]);

    }

    public actualizarMontoPagado(monto, idConfirmacion,total) {
        this.fbstore.collection('confirmaciones').doc(idConfirmacion).update({'montoPagado': monto})
        this.fbstore.collection('confirmaciones').doc(idConfirmacion).update({'liquidada': monto >= total})
    }

    /**
     * Obtiene una lista de pagos con el mismo ID de confirmacion
     * @param id ID de confirmacion
     */
    public listaPagosPorIdConfirmacion(id) {
        return this.fbstore.collection('pagos', ref => ref.where('confirmacion', '==', id))
    }

    public generarKeyPago() {
        return this.fbstore.collection('pagos').add({})
    }

    public subirComprobante(idPAgo, file) {
        return this.firebaseStorage.child('pagos/' + idPAgo + '/' + file.name).put(file)
    }

    public subirIdOficial(idPAgo, file){
        return this.firebaseStorage.child('pagos/' +idPAgo+'/'+ file.name).put(file)
    }

    public actualziarPago(pago,id){
        let objetoModificado={
            aprobacionFinanzas: false,
            confirmacion: pago.confirmacion,
            confirmacionIdTrosten: pago.confirmacionIdTrosten,
            estatus: 'Pagado',
            procesoDePago: pago.procesoDePago,
            formaDePago: pago.formaDePago,
            fechaDePago: pago.fechaDePago,
            total:pago.total,
            subtotal: pago.subtotal || 0,
            iva: pago.iva || 0,
            referencia:pago.referencia,
        }
        if(pago.ordenCompra)
            objetoModificado['ordenCompra']  =pago.ordenCompra;
        if(pago.imagenComprobante)
        {
            objetoModificado['imagenComprobante'] = pago.imagenComprobante
            objetoModificado['fechaSubidaComprobante']=Date.now();
        }
            
        let fechaArreglo=objetoModificado.fechaDePago.split('-');
        objetoModificado.fechaDePago= new Date(Number(fechaArreglo[0]),Number(fechaArreglo[1]-1),Number(fechaArreglo[2])).getTime();
        return this.fbstore.collection('pagos').doc(id).update(objetoModificado)
    }

    public confirmarPago(idPago){
        this.fbstore.collection('pagos').doc(idPago).update({'aprobacionFinanzas':true, 'fechaValidacionFinanzas': Date.now()})
    }
    public desconfirmarPago(idPago){
        this.fbstore.collection('pagos').doc(idPago).update({'estatus':'Cancelado'})
        this.fbstore.collection('pagos').doc(idPago).update({'aprobacionFinanzas':false})
    }

    public cancelarPago(idPago){
        this.fbstore.collection('pagos').doc(idPago).update({'estatus':'Cancelado'})
    }

    public rechazarPago(idPago){
        this.fbstore.collection('pagos').doc(idPago).update({'estatus':'Rechazado', 'fechaRechazoFinanzas': Date.now()})
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/pagos-service.service.ts